module.exports = __webpack_public_path__ + "static/play-0d71dbeba9a3b7bb0014a46a8aefbdda.png";